import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card } from "antd";
import { useNavigate } from "react-router-dom";
import { 
	getClientSummaryCards, 
} from "../../../../../redux/dashboard/dashboardState";
import { displayIcon } from "variables/icons";

const DASHBOARD_CARDS = [
  {
    route: "/console/employee-details",
    icon: "Users",
    iconBg: "flat-blue",
    gradient: "blue",
  },
  {
    route: "/console/attendance-overview",
    icon: "Calendar",
    iconBg: "flat-teal",
    gradient: "teal",
  },
  {
    route: "/console/training-overview",
    icon: "TrendingUp",
    iconBg: "flat-orange",
    gradient: "orange",
  },
  {
    route: "",
    icon: "DollarSign",
    iconBg: "flat-purple",
    gradient: "purple",
  },
];

const DashboardSummaryCard = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  
  const handleClick = (route) => {
    if (route) navigate(route);
  };
  
  const clientSummaryCards = useSelector((state) => state.dashboard.clientSummaryCards.items);

  useEffect(() => {
    dispatch(getClientSummaryCards());
  },[dispatch]);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {clientSummaryCards?.map((card, index) => {
        return (
        <Card
          key={index}
          onClick={() => handleClick(DASHBOARD_CARDS[index]?.route)}
          className="flex flex-col gap-6 rounded-xl cursor-pointer hover:shadow-lg transition-all border border-slate-200 dark:border-zinc-700 dark-mode-card"
        >
          <div className="flex flex-row items-center justify-between px-6 pt-6 pb-2">
            <h4 className="text-[14px] title-text">{card.smr_title}</h4>
            <div className={`p-2 bg-text ${DASHBOARD_CARDS[index]?.iconBg}`}>
              {displayIcon(DASHBOARD_CARDS[index]?.icon, "w-4 h-4")}
            </div>
          </div>
          <div className="px-6 pb-6">
            <div className={`text-[32px] font-semibold label-gradient ${DASHBOARD_CARDS[index]?.gradient}`}>
              {card.smr_value?.value}
            </div>
            <p className="text-[12px] muted-text">{card.smr_description}</p>
          </div>
        </Card>
         );
      })}
    </div>
  );
};

export default DashboardSummaryCard;
